import { Plus } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { SectionHeading } from "@/components/SectionHeading";
import { FadeUp } from "@/components/motion/Reveal";

const WHY_IMAGE =
  "https://images.pexels.com/photos/9616959/pexels-photo-9616959.jpeg?auto=compress&cs=tinysrgb&w=1200";

export function WhyUs() {
  const { t } = useLanguage();

  return (
    <section id="warum" data-testid="why-section" className="bg-white py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading
          index={t.sections.why.index}
          label={t.sections.why.label}
          title={t.sections.why.title}
          sub={t.sections.why.sub}
        />

        <div className="grid gap-12 lg:grid-cols-2 lg:gap-20">
          <div>
            <div className="divide-y divide-border border-y border-border">
              {t.why.map((item, i) => (
                <FadeUp key={i} delay={i * 0.06}>
                  <div
                    data-testid={`why-item-${i + 1}`}
                    className="group flex items-center gap-5 py-5"
                  >
                    <span className="grid h-8 w-8 shrink-0 place-items-center border border-border transition-colors duration-300 group-hover:border-brand group-hover:bg-brand">
                      <Plus className="h-4 w-4 text-navy transition-colors duration-300 group-hover:text-white" strokeWidth={2} />
                    </span>
                    <span className="font-display text-lg font-medium tracking-tight text-navy md:text-xl">
                      {item}
                    </span>
                  </div>
                </FadeUp>
              ))}
            </div>

            <FadeUp delay={0.2}>
              <div className="mt-10 border-l-2 border-brand bg-navy-50 p-7" data-testid="why-highlight-card">
                <h3 className="mb-2 font-display text-lg font-bold tracking-tight text-navy">
                  {t.whyCard.title}
                </h3>
                <p className="text-sm leading-relaxed text-muted-foreground">{t.whyCard.text}</p>
              </div>
            </FadeUp>
          </div>

          <FadeUp delay={0.15} className="relative">
            <div className="relative h-full min-h-[420px] overflow-hidden">
              <img
                src={WHY_IMAGE}
                alt="Architectural planning"
                className="absolute inset-0 h-full w-full object-cover grayscale-[35%]"
              />
              <div className="absolute inset-0 bg-navy/15" />
              <div className="absolute bottom-0 left-0 right-0 border-t border-white/20 bg-navy-deep/85 p-6 backdrop-blur-sm">
                <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/60">
                  ArStudio Elektro — {t.sections.why.label}
                </p>
              </div>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
